import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import mail_icon from '../../assets/images/mail_icon.png';
import BackIcon from '@mui/icons-material/ArrowBack';

const styles = theme => ({
  root: {
    height: '100vh',
    background:
      'linear-gradient(0deg, rgba(125,204,230,1) 0%, rgba(87,166,219,1) 100%)',
  },
  heading: {
    color: '#fff',
    fontSize: 27,
    fontWeight: 'light',
  },
  subheading: {
    color: '#fff',
    fontsize: 17,
    fontWeight: 'light',
    marginTop: 40,
  },
  pharmacyNameBox: {
    backgroundColor: '#fff',
    width: '80%',
    height: 50,
    borderRadius: 40,
    marginTop: 10,
  },
  pharmacyName: {
    color: '#238CB9',
    fontSize: 16,
    fontWeight: 600,
  },
  mailIcon: {
    marginTop: 50,
  },
  confirmHeading: {
    marginTop: 60,
    fontSize: 18,
    fontWeight: 600,
    color: '#fff',
  },
  confirmBody: {
    fontSize: 12,
    fontWeight: 200,
    color: '#fff',
  },
  confirmBodyBox: {
    marginTop: 30,
    maxWidth: 300,
  },
  backIcon: {
    zIndex: 200,
    position: 'absolute',
    left: 24,
    top: 40,
    color: '#fff',
  },
});

const Welcome = ({
  classes,
  match: {
    params: {pharmacyName},
  },
}) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      className={classes.root}>
      <Link href="/">
        <BackIcon className={classes.backIcon} />
      </Link>
      <Box
        width="100%"
        flexDirection="column"
        display="flex"
        alignItems="center">
        <Typography variant="h5" component="p" className={classes.heading}>
          Willkommen!
        </Typography>
        <Typography
          variant="body1"
          component="p"
          className={classes.subheading}>
          Deine Apotheke:
        </Typography>
        <Box
          flexDirection="column"
          display="flex"
          alignItems="center"
          justifyContent="center"
          className={classes.pharmacyNameBox}>
          <Typography
            variant="body1"
            component="p"
            className={classes.pharmacyName}>
            {pharmacyName}
          </Typography>
        </Box>
        <img src={mail_icon} alt="Logo" className={classes.mailIcon} />
        <Typography
          variant="body1"
          component="p"
          className={classes.confirmHeading}>
          Jetzt Konto bestätigen
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          className={classes.confirmBodyBox}>
          <Typography
            variant="body1"
            component="p"
            className={classes.confirmBody}>
            Bitte überprüfe Deine Angaben und verifiziere abschließend Deine
            E-Mail-Adresse um die ersten Schulungsinhalte zu aktivieren.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default withStyles(styles)(Welcome);
